module.exports = __webpack_public_path__ + "static/media/revistart boton.44f13966.png";